<template>
  <section class="core">
    <div class="container">
      <a-typography-title :level="1">
        核心功能
      </a-typography-title>
      <a-row :gutter="[50,$Store.Public().isGridMatch('>=',$Enum.GridEnum.MD)?20:5]">
        <a-col v-for="(item,index) in expand.list"
               :xs="24" :md="12" :lg="{offset:index%2?0:1,span:11}" :xl="{offset:index%2?0:2,span:10}">
          <div class="item" :class="`i_${index+1}`">
            <a-typography-title :level="5">
              {{ item.title }}
            </a-typography-title>
            <a-typography-paragraph>
              <span v-for="v in item.text">
                {{ v }}
              </span>
            </a-typography-paragraph>
          </div>
        </a-col>
      </a-row>
      <!-- <a-space :size="$Store.Public().isGridMatch('>=',$Enum.GridEnum.XL)?'large':'small'">
        <a-button type="link" class="button_n_2"
                  @click="clickToCloud()">
          立刻在线体验
        </a-button> -->
        <!--<a-button type="link" class="button_1"-->
        <!--       @click="$Store.Page().openModal('modalFormCollection', 'deployment')">-->
        <!--  预约私有化部署-->
        <!--</a-button>-->
      <!-- </a-space> -->
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';

export default {
  name: 'product_core',
  data(): DataInterface {
    return {
      expand: {
        list: [
          {
            title: '自动部署',
            text: [
              '开发者只需提交Release的代码，InfraPilot便会自动构建镜像，自动按照模板配置并完成应用部署。'
            ]
          },
          {
            title: '快速压测',
            text: [
              '评估能让应用稳定运行的最佳规格，保持较高资源利用率。自动配置弹性策略，实现自动弹性伸缩功能。'
            ]
          },
          {
            title: '应用监控',
            text: [
              '通过监控应用可用性指标，识别故障类型，并及时进行干预，实现故障自治理。'
            ]
          },
          {
            title: '故障自愈',
            text: [
              '支持重启、降级、回滚、切流量等故障自愈操作，使应用系统实现无需监管的自运转能力。'
            ]
          }
        ]
      }
    };
  },
  methods: {
    /**
     * 点击去云平台
     */
    clickToCloud(): void {
      // location.href = $Config.Href.cloud;
      open($Config.Href.cloud);
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}page/productInfraPilot/';

.core {
  overflow: hidden;
  position: relative;
  padding: 0 @padding;
  background: @color_white;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: @space 0;
    margin: 0 auto;
    .borderBox();
    text-align: center;
  }
}

h1.ant-typography {
  margin: 0;
  .font(center, @title, @color_12, @title, true);
}

.ant-row {
  margin: @margin 0 0;
}

.item {
  @wh: 80px;
  position: relative;
  min-height: 92px;
  padding: 5px 20px 5px 100px;
  
  .loop(@i) when (@i<=4) {
    &.i_@{i} {
      &::before {
        background-position-x: -(-1+@i)*@wh;
      }
    }
    .loop(@i+1);
  }
  .loop(1);
  
  &::before {
    content: '';
    display: block;
    .position(absolute, 0, auto, auto, 0);
    z-index: 0;
    width: @wh;
    height: @wh;
    .bg('@{image}core_icon.png', @wh*4, @wh);
  }
  
  h5.ant-typography {
    margin: 0;
    .font(justify, @text_big, @color_12, @text_big, true);
  }
  
  div.ant-typography {
    margin: @margin_mo 0 0;
    .font(justify, @text+@line, @color_13, @text);
    
    span {
      display: block;
    }
  }
}

.ant-space {
  margin: @margin 0 0;
}

@media screen and (max-width: -1px+@grid_md) {
  .core {
    .container {
      padding: @space_mo 0;
    }
  }
  
  h1.ant-typography {
    .font(center, @title_mo+@line_mo, @color_12, @title_mo, true);
  }
  
  .ant-row {
    margin: @margin_mo 0 0;
  }
  
  .item {
    max-width: 350px;
    min-height: auto;
    padding: 0;
    margin: 0 auto;
    
    &::before {
      .position(absolute, -30px, auto, auto, -25px);
      margin: 0;
      .transform(scale(0.5));
    }
    
    h5.ant-typography {
      padding: 0 0 0 45px;
      margin: @margin_mo 0 0;
      .font(justify, @text_big_mo, @color_12, @text_big_mo, true);
    }
    
    div.ant-typography {
      margin: @margin_mo 0 0;
      .font(justify, @text_mo+@line_mo, @color_13, @text_mo);
    }
  }
}
</style>